export const checkMediaPermission = (media) => {
  return async () => {
    const ret = await navigator.permissions.query({ name: media })
    return ret.state
  }
}

export const microphoneState = checkMediaPermission('microphone')
export const cameraState = checkMediaPermission('camera')

export const getMediaPermission = () => {
  return navigator.mediaDevices.getUserMedia({
    audio: true,
    video: true
  }).then(res => res).catch(() => false)
}

export const getNavigatorLanguage = () => {
  if (navigator.languages && navigator.languages.length) {
    if (navigator.languages[0].indexOf('zh') > -1) return 'zh-hant'
    return navigator.languages[0]
  } else {
    const language = navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en'
    if (language.indexOf('zh') > -1) return 'zh-hant'
    return language
  }
}

export const judgeIfIsIphoneSafari = () => {
  const ua = navigator.userAgent.toLowerCase()

  if (
    ua.indexOf('applewebkit') > -1 &&
    ua.indexOf('mobile') > -1 &&
    ua.indexOf('safari') > -1 &&
    ua.indexOf('linux') === -1 &&
    ua.indexOf('android') === -1
  ) {
    return true
  }
  return false
}
